<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :elevation="hover ? 6 : 2"
      class="ma-1"
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-icon
            :class="statusIcon.color"
            x-large
            v-text="statusIcon.text"
          />
        </v-list-item-avatar>
        <v-list-item-content style="margin-left: -8px;">
          <v-list-item-title class="headline">
            {{ rfq._id }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ moment(rfq.ExpiryDate).format('YYYY-MM-DD') }} -
            <span :class="statusIcon.color">
              {{ rfq.Status }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(action, i) in quoteActions"
                :key="i"
                :disabled="['view', 'email'].includes(action.type) && !rfq.FilePath"
                @click="$emit('action:clicked', action.type)"
              >
                <v-list-item-title>
                  {{ action.label }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>

      <v-row justify="center">
        <v-col cols="auto">
          <span
            class="display-1 font-weight-light"
          >
            {{ `${rfq.NumLines} Parts` }}
          </span>

          <span class="display-1 font-weight-light">
            -
          </span>
        </v-col>

        <v-col cols="auto">
          <span class="display-1 font-weight-light">
            {{ formatCurrency(rfq.pricing, true) }}
          </span>
        </v-col>
      </v-row>

      <v-card-actions class="pt-0">
        <div class="d-flex" style="width: 100%">
          <div class="d-flex align-end">
            <core-ownerships
              :value="{
                createdBy: rfq.CreatedByUserName,
                createdByEmail: rfq.CreatedByUserName,
                createdAt: rfq.CreateDate,
              }"
            />
          </div>

          <v-spacer />

          <v-btn
            icon
            @click="!isExpanded && $emit('viewParts:clicked'); isExpanded = !isExpanded;"
          >
            <v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
      </v-card-actions>
      <v-expand-transition>
        <core-rfq-parts-table v-show="isExpanded" :rfq-id="rfq._id" />
      </v-expand-transition>
    </v-card>
  </v-hover>
</template>

<script>
import { mapState } from 'vuex';
import CurrencyFormatterMixin from '../../../mixins/currencyFormatter';

export default {
  name: 'RFQCard',

  mixins: [
    CurrencyFormatterMixin,
  ],

  props: {
    rfq: {
      type: Object,
      required: true,
    },

    quoteActions: {
      type: Array,
    },
  },

  data() {
    return {
      isExpanded: false,
    };
  },

  computed: {
    ...mapState('auth', {
      accessToken: 'accessToken',
    }),

    statusIcon() {
      const icon = {
        color: 'green--text',
        text: 'mdi-check',
      };

      const { status } = this.rfq;
      switch (status) {
        case 'Awaiting Pricing':
        case 'On Hold':
          icon.text = 'mdi-timer-sand';
          icon.color = 'amber--text lighten-1';
          break;
        case 'Valid Offer':
          icon.text = 'mdi-check';
          icon.color = 'green--text';
          break;
        case 'Offer Expired':
          icon.text = 'mdi-clock-outline';
          icon.color = 'red--text';
          break;
        default:
          break;
      }
      return icon;
    },
  },
};
</script>

<style scoped>

</style>
